export default __webpack_public_path__ + "static/media/satsense_logo.328073bb.svg";